export default function Configure($stateProvider) {
	$stateProvider.state('tgap-exclure', {
		parent: 'gestion',
		url: '/tgap-exclure',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
		}
	});
}

Configure.$inject = ['$stateProvider'];
